"use strict";
var acknowledgements_component_1 = require("./acknowledgements.component");
exports.AcknowledgementsComponent = acknowledgements_component_1.AcknowledgementsComponent;
var acknowledgement_selector_component_1 = require("./acknowledgement-selector.component");
exports.AcknowledgementSelectorComponent = acknowledgement_selector_component_1.AcknowledgementSelectorComponent;
var acknowledgement_service_1 = require("./acknowledgement.service");
exports.AcknowledgementService = acknowledgement_service_1.AcknowledgementService;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/acknowledgements/index.js